<template>
  <div class="tabItem">
    <div class="qylc minBox">
      <div class="aboutSectionTitle aboutSectionTitleC">
        <div class="CNtitle">企业历程</div>
        <div class="ENtitle">OUR JOURNEY</div>
        <div class="titleLine"></div>
      </div>
      <div class="lcItem lcItem1">
        <div class="lcPro">
          <div class="topIcon">
            <img src="~@/assets/img/aboutUs/lichengIcon.png" alt />
          </div>
          <div class="proList">
            <pro-item v-for="(item,index) in proList1" :key="index" :itemData="item" />
          </div>
        </div>
        <div class="lcImg">
          <img src="~@/assets/img/aboutUs/lichengImg2.png" alt="">
        </div>
      </div>
      <div class="lcItem lcItem2">
        <div class="lcImg">
          <img src="~@/assets/img/aboutUs/lichengImg1.png" alt="">
        </div>
        <div class="lcPro">
          <div class="topIcon">
            <img src="~@/assets/img/aboutUs/lichengIcon.png" alt />
          </div>
          <div class="proList">
            <pro-item v-for="(item,index) in proList2" :key="index" :itemData="item" />
          </div>
        </div>
      </div>
    </div>
    <div class="fzbj minBox">
      <div class="aboutSectionTitle">
        <div class="CNtitle">发展布局</div>
        <div class="ENtitle">Development layout</div>
        <div class="titleLine"></div>
      </div>
      <div class="developText">《盛世收藏》致力于在全国各地发展分店，将中国传统文化带进千家万户。规划在全国各省会城市发展省级分店，以省级分店为中心逐步发展县市级分店，最终覆盖全省以至于覆盖全国</div>
      <div class="developText">现阶段正着手大力发展浙江省境内全覆盖，目前以杭州总店为中心，已覆盖并开设嘉兴店。</div>
      <div class="fzImg">
        <img src="~@/assets/img/aboutUs/map.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import ProItem from "./proItem";
export default {
  name: "tabItem",
  components: {
    ProItem
  },
  data() {
    return {
      proList1: [
        {
          iconSize: "28px",
          date: "2008年",
          text: ["创立《盛世收藏》品牌"]
        },
        {
          iconSize: "28px",
          date: "2009年",
          text: ["《盛世收藏》杭州店开业"]
        },
        {
          iconSize: "18px",
          date: "2010年",
          text: ["《盛世收藏》兰州店开业"]
        },
        {
          iconSize: "18px",
          date: "2012年",
          text: ["《盛世收藏》西安店开业"]
        },
        {
          iconSize: "28px",
          date: "2013年",
          text: ["创立杭州捷雅文化创意有限公司"]
        }
      ],
      
      proList2: [
        {
          iconSize: "28px",
          date: "2014年",
          text: ["创立陕西中鼎国藏文化传播有限公司"]
        },
        {
          iconSize: "28px",
          date: "2015年",
          text: ["创立杭州中鼎国藏文化传播有限公司"]
        },
        {
          iconSize: "18px",
          date: "2016年",
          text: ["《盛世艺术馆》开馆"]
        },
        {
          iconSize: "28px",
          date: "2017年",
          text: ["创立浙江中臻盛典控股有限公司","创立杭州凌浩网络科技有限公司"]
        },
        {
          iconSize: "18px",
          date: "2018年",
          text: ["《盛世收藏》嘉兴店开业","创立嘉兴捷雅文化传播有限公司"]
        }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/index.scss';
.tabItem {
  width: 100%;
  background: #f2f2f2;
  .qylc {
    padding-top: 70px;
    .lcItem1{
      .lcPro {
        margin-left: 125px;
        width: 500px;
        .proList{
          padding-bottom: 50px;
        }
      }
      .lcImg{
        width: 556px;
        height: 600px;
        padding-top: 76px;
      }
    }
    .lcItem2{
      .lcImg{
        width: 506px;
        height: 602px;
        padding-top: 74px;
      }
      .lcPro {
        margin-left: 180px;
      }
    }
    .lcItem {
      padding: 60px 0;
      display: flex;
      .lcPro {
        .topIcon {
          width: 120px;
          height: 120px;
        }
        .proList {
          border-left: 2px solid $aboutRed;
          margin-left: 59px;
          padding-top: 24px;
        }
      }
    }
  }
  .fzbj{
    .developText{
      width: 840px;
      line-height: 28px;
      margin-top: 30px;
      font-size: 14px;
      color: #333;
    }
    .fzImg{
      margin-top: 72px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aboutUs/components/tabItem2.vue